export default __webpack_public_path__ + "static/media/TechBairn.0dfd7ae7.jpeg";